export const routePaths = {
  // リセラー運営（ホスト）専用。テナントに属さないため :tenantId を持たない
  admin: {
    tenants: {
      path: "admin/tenants",
      getHref: () => "/admin/tenants" as const,
    },
    // バナー生成のプレースホルダ。全テナント共通のため :tenantId を持たない
    placeholders: {
      path: "admin/placeholders",
      getHref: () => "/admin/placeholders" as const,
    },
  },
  // テナント配下の画面。API と同じく対象テナントをパスに載せる
  tenants: {
    root: {
      path: "tenants/:tenantId",
      getHref: (tenantId: string) => `/tenants/${tenantId}` as const,
    },
    imageLibrary: {
      path: "tenants/:tenantId/image-library",
      relativePath: "image-library",
      getHref: (tenantId: string) =>
        `/tenants/${tenantId}/image-library` as const,
    },
    reportLibrary: {
      path: "tenants/:tenantId/report-library",
      relativePath: "report-library",
      getHref: (tenantId: string) =>
        `/tenants/${tenantId}/report-library` as const,
    },
    bannerAnalysis: {
      root: {
        path: "tenants/:tenantId/banner-analysis",
        relativePath: "banner-analysis",
        getHref: (tenantId: string) =>
          `/tenants/${tenantId}/banner-analysis` as const,
      },
      // CSV からの依頼
      create: {
        path: "tenants/:tenantId/banner-analysis/new",
        relativePath: "new",
        getHref: (tenantId: string) =>
          `/tenants/${tenantId}/banner-analysis/new` as const,
      },
    },
    // 管理領域。作業画面と違い、ホストと管理者だけが入れる
    manage: {
      root: {
        path: "tenants/:tenantId/manage",
        relativePath: "manage",
      },
      users: {
        path: "tenants/:tenantId/manage/users",
        /** manage ルートからの相対 */
        relativePath: "users",
        /** tenants/:tenantId からの相対。テナント配下のナビが使う */
        relativeFromTenant: "manage/users",
        getHref: (tenantId: string) =>
          `/tenants/${tenantId}/manage/users` as const,
      },
    },
  },
} as const;
